/**
* 基础菜单 账号管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.username" placeholder="账号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.phone" placeholder="手机号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="请选择状态" clearable>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.seller_code" placeholder="店铺商家编号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="addUser" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editUser" class="edit-button">修改</el-button>
        <el-button size="small" type="warning" @click="setRole">分配角色</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="账号" min-width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="180">
        </el-table-column>
        <el-table-column prop="role_name" label="角色名称" min-width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="status" label="有效状态" width="90">
          <template slot-scope="scope">
            <el-switch @change="changeStatus(scope.row.id,scope.row.status)"
                       v-model="scope.row.status"
                       :active-value="1"
                       :inactive-value="0"
                       active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="receive_message" label="是否接收短信" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.receive_message==1">是</div>
            <div v-else>否</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="200">
        </el-table-column>
        <el-table-column prop="create_name" label="创建人" width="200">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="attrDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="addForm" :rules="addRules" ref="addForm" class="attrForm">
        <el-form-item label="账号" prop="username" class="relative r50">
          <el-input size="small" v-model="addForm.username" auto-complete="new-password" clearable maxlength="20"
                    placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" class="relative r50">
          <el-input type="password" size="small" v-model="addForm.password" auto-complete="new-password" clearable maxlength="20"
                    class="pswd"
                    placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" class="relative r50">
          <el-input size="small" v-model="addForm.phone" auto-complete="off" clearable maxlength="11"
                    placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="有效状态" prop="status" class="relative r50">
          <el-select v-model="addForm.status" placeholder="请选择有效状态" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否接收短信" prop="receive_message" class="relative r50">
          <el-select v-model="addForm.receive_message" placeholder="请选择是否接收短信" clearable>
            <el-option v-for="item in messageList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveSort('addForm')" :disabled="!isCanSubmit">保存</el-button>
            <el-button @click="handleClose()">取 消</el-button>

      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="分配角色"
               :visible.sync="setRoleDialogVisible"
               width="30%"
               center>
      <el-form label-width="155px" :model="setRoleForm"  :rules="setRoleRules" ref="setRoleForm" class="attrForm">
        <el-form-item label="账号" prop="name" class="relative r50">
          <el-input size="small" v-model="name" auto-complete="off" clearable maxlength="100" disabled
                    placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleIds">
          <el-select v-model="setRoleForm.roleIds" multiple placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveRoleButton('setRoleForm')" :disabled="!isCanSubmit">保存</el-button>
            <el-button @click="setRoleDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    userList
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from '../../api/commonMG'

  export default {
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入手机号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        attrDialogVisible: false,  // 弹窗
        setRoleDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        selectTableData: [],
        productId: '',
        productOptions: [],
        productOptionsHome: [],
        formInline: {
          page: 1,
          rows: 10,
          username: '',
          phone: '',
          status: '',
          seller_code: ''
        },
        addRules: {
          username: [{required: true, message: '请输入账号', trigger: 'blur'}],
          password: [{required: true, message: '请输入密码', trigger: 'blur'}],
          phone: [{required: true, validator: validateNum, trigger: 'blur'}],
          status: [{required: true, message: '请选择有效状态', trigger: 'blur'}],
          receive_message: [{required: true, message: '请选择是否接收短信', trigger: 'blur'}],
        },
        setRoleRules:{
          roleIds: [{required: true, message: '请选择角色', trigger: 'blur'}],
        },
        addForm: {
          id: '',
          username: '',
          password: "",
          phone: "",
          status: '',
          receive_message: ''
        },
        defaultParams: {
          label: 'text',
          value: 'id',
          children: 'children'
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        isCanSubmit: true,
        statusList: [{
          name: '有效',
          value: 1
        }, {
          name: '无效',
          value: 0
        }],
        messageList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        setRoleForm: {
          userId: '',
          roleIds: []
        },
         name: '',
        options: [],
        isSuper:'0'
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.isSuper = localStorage.getItem('isSuper')||'0'
      this.getdata(this.formInline)
    },
    methods: {
      // 新增动态属性
      addUser() {
        this.attrDialogVisible = true;
        this.dialogTitle = '新增账号';
        this.addForm = {};
      },
      // 修改动态属性
      editUser() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.dialogTitle = '修改账号';
        this.attrDialogVisible = true;
        userDetail(this.selectTableData[0].id)
          .then(res => {
            if (res.success) {
              this.addForm = res.content;
              // this.addForm.password = '******'
            }
          })
          .catch(err => {
          })
        this.productId = this.selectTableData[0].id;
      },
      // 分配角色
      setRole() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.setRoleDialogVisible = true;
        this.setRoleForm.userId = this.selectTableData[0].id;
        this.name = this.selectTableData[0].username;
        this.setRoleForm.roleIds = [];
        let data = {}
        roleSelectList(data)
          .then(res => {
            if (res.success) {
              this.options = res.content
            }
          })
          .catch(err => {
          })
        userRoleList(this.selectTableData[0].id)
          .then(res => {
            if (res.success) {
              this.setRoleForm.roleIds = res.content
            }
          })
          .catch(err => {
          })
      },
      changeStatus(id, status) {
        if (!status) {
          userDisable(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          userEnable(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        userList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增动态属性
      saveSort(formName) {
        if (this.dialogTitle == '修改账号') {
          this.addForm.id = this.productId;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增账号') {
              userAdd(this.addForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加账号!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              userUpdate(this.addForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改账号!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      saveRoleButton(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            setRole(this.setRoleForm)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功分配角色!'
                  });
                  this.setRoleDialogVisible = false
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }
        })
      },
      productSortChange(sort_id, type) {

      },
      // 搜索事件
      search() {
        if (this.formInline.sort_id && typeof (this.formInline.sort_id) != 'string') {
          this.formInline.sort_id = this.formInline.sort_id.pop()
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["addForm"].resetFields();
        this.attrDialogVisible = false;
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.attr_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .attrForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .attrForm .el-input {
    width: 320px;
  }

  /deep/ .attrForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .attrForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .attrForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .attrForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .attrForm .el-input--small {
    width: 320px;
  }

  /deep/ .pswd .el-input__inner {
    padding-right: 135px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

</style>





// WEBPACK FOOTER //
// src/views/power/account.vue